import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { api } from '../../services/api'; // 請記得在 api.ts 擴充 getOrderStatus

export default function CheckoutResult() {
  const [searchParams] = useSearchParams();
  const orderNo = searchParams.get('orderNo');
  const { token } = useAuth();
  
  const [status, setStatus] = useState<'LOADING' | 'PAID' | 'FAILED' | 'PENDING'>('LOADING');

  useEffect(() => {
    const checkStatus = async () => {
      if (!orderNo || !token) {
        setStatus('FAILED');
        return;
      }

      try {
        // 呼叫我們剛寫好的 GET /api/checkout/status/:orderNo
        const response = await fetch(`${import.meta.env.VITE_API_URL}/checkout/status/${orderNo}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        
        setStatus(data.status); // PENDING, PAID, 或是 FAILED
      } catch (error) {
        console.error(error);
        setStatus('FAILED');
      }
    };

    checkStatus();

    // 如果還是 PENDING，可以設定每 3 秒發送一次請求輪詢 (Polling)，
    // 因為金流伺服器的 Webhook 可能比瀏覽器轉址慢個 1~2 秒到達
    let interval: any;
    if (status === 'PENDING') {
      interval = setInterval(checkStatus, 3000);
    }
    
    return () => clearInterval(interval);

  }, [orderNo, token, status]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg border border-fog-mid text-center max-w-md w-full">
        
        {status === 'LOADING' || status === 'PENDING' ? (
          <>
            <i className="ri-loader-4-line text-6xl text-accent-orange animate-spin block mb-6"></i>
            <h2 className="text-2xl font-bold text-text-dark mb-2">確認付款結果中</h2>
            <p className="text-text-muted">請稍候，正在與銀行連線確認您的訂單...</p>
          </>
        ) : status === 'PAID' ? (
          <>
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-check-line text-5xl text-green-500"></i>
            </div>
            <h2 className="text-2xl font-bold text-text-dark mb-2">付款成功！</h2>
            <p className="text-text-muted mb-8">感謝您的購買，序號已經派發至您的序號庫。</p>
            <Link 
              to="/member"
              className="inline-block w-full bg-accent-orange text-white py-3 rounded-full font-bold hover:bg-accent-orange/90 transition-colors"
            >
              前往查看序號
            </Link>
          </>
        ) : (
          <>
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-close-line text-5xl text-red-500"></i>
            </div>
            <h2 className="text-2xl font-bold text-text-dark mb-2">付款失敗</h2>
            <p className="text-text-muted mb-8">交易未能完成，請確認您的信用卡狀態或重新嘗試。</p>
            <Link 
              to="/"
              className="inline-block w-full border border-fog-dark text-text-dark py-3 rounded-full font-bold hover:border-accent-orange transition-colors"
            >
              回到首頁
            </Link>
          </>
        )}
      </div>
    </div>
  );
}